/* TAB 3 — OUT. Hành vi y v4, tầng ghi đổi:
   - RAM nói đã pick → out ngay trong RAM, do_out vào hàng đợi nền (force nếu pick từ ngày trước)
   - RAM nói CHƯA pick → hỏi máy chủ 1 lần (~150 ms) rồi mới chặn (tránh chặn oan khi
     máy khác vừa pick mà realtime chưa tới); máy chủ nói ok thì nhận luôn
   - máy chủ trả ALREADY_OUT / NOT_FOUND sau khi đã out cục bộ → hoàn tác + báo đỏ */
import * as K from '../core/index.js';
import { S, findByCode, statOf, statLabel, upsertLocal, localOut, localUndoOut } from '../store.js';
import { rpc } from '../lib/supabase.js';
import { enqueue } from '../lib/queue.js';
import { $, esc, log, dialog, beep, flash, fmt, todayISO, dayOf, vnTime } from '../lib/ui.js';
import { saveSheets } from '../lib/xlsx.js';

const ot = { filter: '' };   // '' = tất cả hãng

export function initTab3() {
  $('#otScan').addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const v = K.norm(this.value).toUpperCase().replace(/[^0-9A-Z]/g, '');
    this.value = ''; if (v) otLookup(v);
  });
  const d = new Date(), p = (x) => String(x).padStart(2, '0');
  $('#otFrom').value = d.getFullYear() + '-' + p(d.getMonth() + 1) + '-01';
  $('#otTo').value = todayISO();
  $('#otStatBtn').onclick = otStats;
}
export function otEnter() {
  const ready = Object.keys(S.orders).length > 0;
  $('#otEmpty').style.display = ready ? 'none' : '';
  $('#otMain').style.display = ready ? '' : 'none';
  if (!ready) return;
  otRefresh();
  setTimeout(() => $('#otScan').focus(), 80);
}

/* tiến độ: mẫu số = số đơn đã pick */
export function otRefresh() {
  let need = 0, done = 0; const chan = { SHOPEE: { n: 0, d: 0 }, TIKTOK: { n: 0, d: 0 } };
  Object.values(S.orders).forEach((o) => {
    if (o.pickState !== 'done') return;
    need++; chan[o.channel].n++;
    if (o.outState === 'done') { done++; chan[o.channel].d++; }
  });
  const pc = need ? Math.round(done / need * 100) : 0;
  $('#otBar').style.width = pc + '%';
  $('#otNote').textContent = pc + '%';
  $('#otStats').innerHTML =
    '<div><b>' + done + '<span style="color:var(--ink3)">/' + need + '</span></b> <span>đơn đã nhặt</span></div>' +
    '<div><b class="mono" style="font-size:19px;color:var(--shopee)">' + chan.SHOPEE.d + '/' + chan.SHOPEE.n + '</b> <span>shopee</span></div>' +
    '<div><b class="mono" style="font-size:19px;color:var(--tiktok)">' + chan.TIKTOK.d + '/' + chan.TIKTOK.n + '</b> <span>tiktok</span></div>';
  otTable();
}
function otDoneKeys() {
  return Object.keys(S.orders).filter((k) => S.orders[k].outState === 'done')
    .sort((a, b) => (S.orders[b].outAt || '').localeCompare(S.orders[a].outAt || ''));
}
function otTable() {
  const all = otDoneKeys();
  $('#otListCard').style.display = all.length ? '' : 'none';
  if (!all.length) { $('#otCount').textContent = ''; return; }
  // chip lọc theo hãng (gộp bằng carrierGroup, tách SPX Express / Instant)
  const cnt = {};
  all.forEach((k) => { const g = K.carrierGroup(S.orders[k].carrier); cnt[g] = (cnt[g] || 0) + 1; });
  if (ot.filter && !cnt[ot.filter]) ot.filter = '';
  const groups = Object.keys(cnt).sort((a, b) => cnt[b] - cnt[a] || a.localeCompare(b));
  $('#otFilter').innerHTML = '<button data-g="" class="' + (ot.filter ? '' : 'sel') + '">Tất cả <b>' + all.length + '</b></button>' +
    groups.map((g) => '<button data-g="' + esc(g) + '" class="' + (ot.filter === g ? 'sel' : '') + '">' + esc(g) + ' <b>' + cnt[g] + '</b></button>').join('');
  $('#otFilter').querySelectorAll('button').forEach((b) => { b.onclick = function () { ot.filter = this.dataset.g; otTable(); }; });
  const keys = ot.filter ? all.filter((k) => K.carrierGroup(S.orders[k].carrier) === ot.filter) : all;
  $('#otCount').textContent = keys.length + (ot.filter ? ' đơn ' + ot.filter : ' đơn');
  const rows = ['<tr><th>Mã vận đơn</th><th>Hãng</th><th>Mã đơn hàng</th><th>Kênh</th><th>Tình trạng</th><th>Máy</th><th></th></tr>'];
  keys.forEach((k) => {
    const o = S.orders[k], st = statOf(o), lab = statLabel(st);
    const cls = st.over ? 'p-over' : (st.short ? 'p-short' : (st.sub ? 'p-sub' : 'p-done'));
    rows.push('<tr><td class="bc">' + esc(o.tracking || '') + '</td><td title="' + esc(o.carrier || '') + '">' + esc(K.carrierGroup(o.carrier)) + '</td>' +
      '<td class="bc">' + esc(o.orderId) + '</td><td><span class="chan ' + o.channel + '">' + o.channel + '</span></td>' +
      '<td><span class="badge ' + cls + '">' + esc(lab) + '</span></td>' +
      '<td class="small dim">' + esc(o.pickedMay || '') + ' → ' + esc(o.outMay || '') + '</td>' +
      '<td style="text-align:right"><button class="xbtn" data-k="' + esc(k) + '">bỏ</button></td></tr>');
  });
  $('#otTable').innerHTML = rows.join('');
  $('#otTable').querySelectorAll('.xbtn').forEach((b) => {
    b.onclick = function () {
      const k = this.dataset.k, o = S.orders[k];
      localUndoOut(k);
      enqueue({ rpc: 'undo_out', args: { p_order_pk: o.id }, key: k, label: 'bỏ out ' + o.orderId });
      otRefresh();
      otMsg('w', 'Đã bỏ bàn giao đơn <b>' + esc(o.orderId) + '</b>.');
    };
  });
}
function otMsg(type, html) {
  $('#otMsg').innerHTML = html ? '<div class="note ' + type + '"><span class="ic">' + ({ e: '✕', w: '!', s: '✓', i: 'i' }[type] || 'i') + '</span><div>' + html + '</div></div>' : '';
}
function daysAgo(iso) {
  if (!iso) return 0;
  const d = new Date(iso), a = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const n = new Date(), b = new Date(n.getFullYear(), n.getMonth(), n.getDate()).getTime();
  return Math.round((b - a) / 864e5);
}

async function otLookup(v) {
  const { keys } = findByCode(v);
  if (!keys.length) {
    beep('err'); flash('bad');
    otMsg('e', 'Không tìm thấy <b>' + esc(v) + '</b> — không khớp mã vận đơn lẫn mã đơn hàng nào đang xử lý.');
    return;
  }
  let key = keys.find((k) => S.orders[k].outState !== 'done');
  if (!key) {
    const o0 = S.orders[keys[0]];
    beep('dup'); flash('warn');
    otMsg('w', 'Đơn <b>' + esc(o0.orderId) + '</b> đã bàn giao lúc ' + esc(new Date(o0.outAt).toLocaleTimeString('vi-VN')) + (o0.outMay ? ' bởi ' + esc(o0.outMay) : '') + '. Không quét lại.');
    return;
  }
  const o = S.orders[key];

  if (o.pickState !== 'done') {
    // RAM nói chưa pick — hỏi máy chủ một lần trước khi chặn
    otMsg('i', 'Đang kiểm tra với máy chủ…');
    try {
      const { data, ms } = await rpc('do_out', { p_code: o.tracking || o.orderId, p_force: false, p_op: null });
      if (data.ok) {
        upsertLocal(data.order); beep('done'); flash('ok'); otRefresh();
        const st = statOf(data.order);
        otMsg(st.short || st.sub ? 'w' : 's', 'Đã bàn giao <b>' + esc(o.orderId) + '</b> · ' + esc(statLabel(st)) + ' (máy khác đã pick, máy chủ xác nhận ' + ms + ' ms).');
        return;
      }
      if (data.code === 'OLD_PICK') { upsertLocal(data.order); return otLookup(v); }   // máy khác pick từ hôm trước → đi luồng popup bên dưới
      if (data.code === 'ALREADY_OUT') { upsertLocal(data.order); beep('dup'); flash('warn'); otMsg('w', 'Đơn <b>' + esc(o.orderId) + '</b> đã bàn giao bởi ' + esc(data.outMay || '?') + '. Không quét lại.'); otRefresh(); return; }
    } catch (e) { log('do_out kiểm tra: ' + e.message, 'wr'); }
    beep('warn'); flash('warn');
    otMsg('e', 'Đơn <b>' + esc(o.orderId) + '</b> chưa nhặt hàng — sang tab <b>Pick</b> quét mã vận đơn này để nhặt trước, rồi mới bàn giao được.');
    return;
  }

  const ago = daysAgo(o.pickedAt);
  if (ago >= 1) {
    beep('warn'); flash('warn');
    const dstr = o.pickedAt ? new Date(o.pickedAt).toLocaleDateString('vi-VN') : '?';
    const go = await dialog({
      title: ago > 3 ? 'Đơn pick quá 3 ngày' : 'Đơn pick từ ngày trước',
      body: ago > 3
        ? '<span style="color:var(--bad)"><b>Đơn pick quá 3 ngày có thể đã bị hủy!</b> Check kỹ trước khi out.</span><br><b>' + esc(o.orderId) + '</b> pick ngày ' + esc(dstr) + ' (' + ago + ' ngày trước' + (o.pickedMay ? ', ' + esc(o.pickedMay) : '') + ').'
        : 'Đơn <b>' + esc(o.orderId) + '</b> pick từ ' + esc(dstr) + ' (' + ago + ' ngày trước' + (o.pickedMay ? ', ' + esc(o.pickedMay) : '') + '). Tiếp tục out?',
      buttons: [{ label: 'Hủy', val: false }, { label: 'Tiếp tục out', val: true, cls: 'dang' }]
    });
    if (!go) { otMsg('w', 'Đã hủy bàn giao <b>' + esc(o.orderId) + '</b>.'); $('#otScan').focus(); return; }
  }

  localOut(key);
  enqueue({ rpc: 'do_out', args: { p_code: o.tracking || o.orderId, p_force: ago >= 1 }, key, label: 'out ' + o.orderId });
  beep('done'); flash('ok');
  otRefresh();
  const st = statOf(o);
  otMsg(st.short || st.sub ? 'w' : 's', 'Đã bàn giao <b>' + esc(o.orderId) + '</b> · ' + esc(statLabel(st)) +
    (o.pickedMay && o.pickedMay !== S.may ? ' · pick bởi ' + esc(o.pickedMay) : '') + (o.note ? ' · ' + esc(o.note) : '') + '.');
}

/* --- thống kê giao theo hãng: out_detail(from, to) → 2 sheet --- */
async function otStats() {
  const from = $('#otFrom').value, to = $('#otTo').value;
  if (!from || !to || from > to) { $('#otStatPrev').innerHTML = '<div class="note e"><span class="ic">!</span><div>Chọn khoảng ngày hợp lệ (từ ≤ đến).</div></div>'; return; }
  const btn = $('#otStatBtn'); btn.disabled = true; btn.textContent = 'Đang lấy…';
  try {
    const { data, ms } = await rpc('out_detail', { p_from: from, p_to: to });
    const rows = data || [];
    const days = {}, carriers = {};
    rows.forEach((r) => {
      const d = dayOf(r.outAt), g = K.carrierGroup(r.carrier);
      (days[d] = days[d] || {})[g] = (days[d][g] || 0) + 1;
      carriers[g] = (carriers[g] || 0) + 1;
    });
    const cols = Object.keys(carriers).sort((a, b) => carriers[b] - carriers[a] || a.localeCompare(b));
    const vn = (d) => d.split('-').reverse().join('/');
    const s1 = [['Ngày'].concat(cols, ['Tổng'])];
    Object.keys(days).sort().forEach((d) => { const r = days[d]; s1.push([vn(d)].concat(cols.map((c) => r[c] || 0), [cols.reduce((a, c) => a + (r[c] || 0), 0)])); });
    s1.push(['Tổng'].concat(cols.map((c) => carriers[c]), [rows.length]));
    const s2 = [['Ngày', 'Giờ out', 'Hãng', 'ĐVVC (gốc)', 'Mã vận đơn', 'Mã đơn hàng', 'Kênh', 'Máy pick', 'Máy out', 'Ghi chú']];
    rows.forEach((r) => { const d = new Date(r.outAt); s2.push([vn(dayOf(r.outAt)), d.toLocaleTimeString('vi-VN'), K.carrierGroup(r.carrier), r.carrier || '', r.tracking || '', r.orderId, r.channel, r.pickedMay || '', r.outMay || '', r.note || '']); });
    if (!rows.length) { $('#otStatPrev').innerHTML = '<div class="note w"><span class="ic">!</span><div>Không có đơn bàn giao nào từ ' + vn(from) + ' đến ' + vn(to) + '.</div></div>'; return; }
    saveSheets([{ name: '1. Tổng hợp', rows: s1 }, { name: '2. Chi tiết', rows: s2 }], 'THONG-KE-HANG_' + from.replace(/-/g, '') + '_' + to.replace(/-/g, '') + '.xlsx');
    $('#otStatPrev').innerHTML = '<div class="note s"><span class="ic">✓</span><div><b>' + fmt(rows.length) + ' đơn</b> · ' + Object.keys(days).length + ' ngày · ' + cols.length + ' hãng (' + ms + ' ms): ' +
      cols.map((c) => esc(c) + ' <b>' + fmt(carriers[c]) + '</b>').join(' · ') + '</div></div>';
    log('Thống kê hãng ' + vn(from) + '–' + vn(to) + ': ' + rows.length + ' đơn (' + ms + ' ms)', 'ok');
  } catch (e) {
    $('#otStatPrev').innerHTML = '<div class="note e"><span class="ic">!</span><div>' + esc(e.message) + '</div></div>';
  } finally { btn.disabled = false; btn.textContent = 'Tải thống kê hãng'; }
}

/* máy chủ từ chối thao tác out đã làm cục bộ → hoàn tác */
export function otServerReject(op, data) {
  const o = S.orders[op.key]; if (!o) return;
  if (op.rpc === 'do_out') {
    if (data.order) upsertLocal(data.order); else localUndoOut(op.key);
    beep('err'); flash('bad');
    otMsg('e', 'Máy chủ từ chối bàn giao <b>' + esc(o.orderId) + '</b>: <b>' + esc(data.code) + '</b>' + (data.outMay ? ' — đã out bởi ' + esc(data.outMay) : '') + '. Đã hoàn tác trên máy này.');
    otRefresh();
  }
}
